export class AccUsersForAssignmentResultDto {
    userId: string;
    name: string;
    role: string;
    type: string;
    isPrimary: boolean;
    isBackup: boolean;
}
